import SearchTable from './serach-table';
import wrapper from '../next-wrapper';
const FormSearchTable = wrapper(SearchTable, 'CbayelFormSearchTable');
export default FormSearchTable;
